<script lang="ts">
	import UnsupportedBrowser from './UnsupportedBrowser.svelte'
	import RibbonComponent, { type Ribbon } from './Ribbon.svelte'
	import Search from './Search.svelte'
	import DesktopMenu from './DesktopMenu.svelte'
	import Personal from './Personal.svelte'
	import SubMenu from './SubMenu.svelte'
	import { storefront_prefix } from 'shared/var'
	import type { get_map } from 'shared/json_api/get_related'
	import { onMount } from 'svelte'

	export let ribbons: Ribbon[] = []
	export let storefront_menu_items: ResourceTypes[`storefront_menu_item`][]
	export let included_map: ReturnType<typeof get_map>
	export let the_window: Window | null = null

	let active_menu_id: string | null = null
	let window_width: number

	const menu_href_prefix = `#menu_`

	onMount(() => {
		// when instantiated in ops, stop navigations to other pages
		if (the_window) {
			the_window.addEventListener(`click`, e => {
				const link = (e.target as HTMLElement).closest(`a[href]`) as HTMLAnchorElement | null
				if (!link) {
					return
				}

				if (!link.hash) {
					e.preventDefault()
					link.style.outline = `2px solid red`
					setTimeout(() => {
						// @ts-expect-error TS thinks outline is not nullable, and it's wrong
						link.style.outline = null
					}, 100)
				}
			})
		}

		if (!the_window) {
			the_window = window
		}
		const onHashChange = () => {
			const { hash } = the_window!.location
			active_menu_id = hash.startsWith(menu_href_prefix) ? hash.replace(menu_href_prefix, ``) : null
		}
		onHashChange()

		const onResize = () => {
			window_width = the_window!.innerWidth
		}
		onResize()

		the_window.addEventListener(`hashchange`, onHashChange)
		the_window.addEventListener(`resize`, onResize)

		return () => {
			the_window!.removeEventListener(`hashchange`, onHashChange)
			the_window!.removeEventListener(`resize`, onResize)
		}
	})
</script>

<UnsupportedBrowser />

{#each ribbons as ribbon}
	<RibbonComponent {ribbon} />
{/each}

<div class="header">
	<div class="header_content">
		<div class="desktop flex_horizontal">
			<!-- svelte-ignore a11y-missing-content -->
			<a href={storefront_prefix} class="logo" aria-label="T.REX ARMS Logo"></a>
			<div class="not_logo flex_vertical">
				<Search />

				<div class="flex_horizontal">
					<DesktopMenu {storefront_menu_items} {included_map} {active_menu_id} {menu_href_prefix} />

					<Personal />
				</div>
			</div>
		</div>

		<div class="mobile flex_vertical">
			<div class="flex_horizontal">
				<!-- svelte-ignore a11y-missing-content -->
				<a href={storefront_prefix} class="logo" aria-label="T.REX ARMS Logo"></a>
				<div class="not_logo flex_horizontal">
					<Personal />

					<a class="hamburger" href="{ active_menu_id ? `#` : `${ menu_href_prefix }mobile` }" aria-label="Menu">
						{#if active_menu_id}
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
						{:else}
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
						{/if}
					</a>
				</div>
			</div>

			<Search />
		</div>
	</div>

	{#if active_menu_id}
		<SubMenu {storefront_menu_items} {included_map} {active_menu_id} {window_width} {menu_href_prefix} />
	{/if}
</div>

<style>
	.header {
		background-color: black;
		font-family: 'Protipo', sans-serif;
		--header-height: 110px;
	}

	.header_content {
		align-items: stretch;
		padding: 10px 10px 10px 0;
		max-width: 1040px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
	}

	.flex_horizontal {
		display: flex;
		justify-content: space-between;
		gap: 20px;
	}
	.flex_vertical {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	a.logo {
		background-image: url('https://img.trex-arms.com/brand/TREX_Logo_H_CHEM_WHITE.png?auto=compress&w=600');
		background-repeat: no-repeat;
		background-size: contain;
		--logo-aspect-ratio: .40;
		width: calc(calc(var(--header-height) - 20px) / var(--logo-aspect-ratio));
	}

	.not_logo {
		flex-grow: 1;
	}

	.mobile {
		display: none;
	}

	.hamburger {
		border: 0;
		background: none;
		padding: 0 0.5rem;
		margin: 0;
		color: white;
		cursor: pointer;
		line-height: 40px;
		display: flex;
		align-items: center;
	}

	@media (max-width: 1000px) {
		.header_content {
			padding: 10px;
		}
		a.logo {
			flex-grow: 1;
		}
		.not_logo {
			flex-grow: 0;
			gap: 0;
		}
		.mobile {
			display: flex;
		}
		.desktop {
			display: none;
		}
	}
</style>
